import type { ReactNode } from 'react'
import { motion } from 'framer-motion'
import { ArrowLeft } from 'lucide-react'
import { cn } from '@core/lib/utils'

interface Props {
  children: ReactNode
  className?: string
  onBack?: () => void
}

const AuthCard = ({ children, className, onBack }: Props) => {
  return (
    <motion.div
      className={cn('relative w-full', className)}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.4,
        ease: 'easeOut',
      }}
    >
      {onBack && (
        <motion.button
          type="button"
          onClick={onBack}
          className={cn(
            'absolute -top-12 left-0',
            'flex items-center gap-2 text-sm',
            'text-muted-foreground hover:text-foreground',
            'transition-colors'
          )}
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2 }}
          whileHover={{ x: -3 }}
        >
          <ArrowLeft className="h-4 w-4" />
          Back
        </motion.button>
      )}

      {children}
    </motion.div>
  )
}

export default AuthCard